import style from "./HomeDashboard.module.css";
import React, {useState, useEffect, useRef} from "react";
import HeaderHomePage from "../../components/HeaderHomePage";
import { Bubble1, Bubble2, Bubble3, Bubble4, Bubble5, Bubble6, Bubble7, Bubble8 } from '../../assets';
import { Link } from "react-router-dom";


export default function HomeDashboard(){

    const [number, setNumber] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {

        const observer = new IntersectionObserver(

            ([entry]) => {
                if(entry.isIntersecting){
                    setIsVisible(true);
                }
            }, 
            {
                threshold: 0.5
            }
        );

        if(ref.current)
            observer.observe(ref.current);
        return () => observer.disconnect();

    }, [])

    useEffect(() => {
        
        if(!isVisible) return;

        let start = 0;
        let end = 100;
        const duration = 2000;
        const stepTime = duration/end;

        const timer = setInterval(() => {

            start = start + 1;
            setNumber(start);
            if(start === end){
                clearInterval(timer);
            }
        }, stepTime);

        return () => clearInterval(timer);
    }, [isVisible]);  

    return(
        <div className={style.HomeDashboard_container}>
            
            <HeaderHomePage />

            <div className={style.HomeDashboard_content_animations}>
                <div
                    className={style.feb_intro_floating}
                    data-aos="zoom-in"
                    data-aos-duration="1200" 
                    data-aos-delay="400"
                    style={{display: "flex", justifyContent: "flex-end"}}> <div style={{marginBottom: "2rem", marginRight: "1rem", borderRadius: "100%", backgroundImage: `url(${Bubble1})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "top", height: "80px", width: "80px"}}></div> </div>
                <div 
                    className={style.feb_intro_floating}
                    data-aos="zoom-in"
                    data-aos-duration="1200"
                    data-aos-delay="500"
                    style={{display: "flex", justifyContent: "flex-start"}}> <div style={{marginLeft: "1rem", borderRadius: "100%",  backgroundImage: `url(${Bubble2})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition:"top", height: "111px", width: "111px"}}></div> </div>
                <div 
                    className={style.feb_intro_floating}
                    data-aos="zoom-in"
                    data-aos-duration="1200"
                    data-aos-delay="200"
                    style={{display: "flex", justifyContent: "flex-end"}}> <div style={{borderRadius: "100%", backgroundImage: `url(${Bubble3})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "55%", height: "69px", width: "69px"}}></div> </div>
                <div
                    className={style.feb_intro_floating}
                    data-aos="zoom-in"
                    data-aos-duration="1200" 
                    data-aos-delay="600"
                    style={{display: "flex", justifyContent: "flex-start"}}> <div style={{marginLeft: "2rem", borderRadius: "100%", backgroundImage: `url(${Bubble4})`, backgroundRepeat: "no-repeat",  backgroundSize: "cover", backgroundPosition: "center", height: "118px", width: "118px"}}></div> </div>
            </div>


            <div className={style.HomeDashboard_content_text} data-aos="fade-up">
                <h1>Where Great Talent Meets Great Companies</h1>
                <p>Step into a world where the right talent meets the right opportunity</p>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: "1rem", marginBottom: "1rem"}}>
                    <Link to="/hire-a-talent" className={`${style.feb_intro_button1}`}>Hire a talent</Link>
                    {/* <Link to="/upload-your-resume" className={`${style.feb_intro_button2}`}>Upload CV</Link> */}
                    <Link to="/jobs" className={`${style.feb_intro_button2}`}>Find a Job</Link>
                </div>
                <p><span style={{color: "#28C700"}} ref={ref}>{number}+</span> Candidature Placed</p>
            </div>


            <div className={style.HomeDashboard_content_animations}>

                <div 
                    className={style.feb_intro_floating}
                    data-aos="zoom-in"
                    data-aos-duration="1200"
                    data-aos-delay="400"
                    style={{display: "flex", justifyContent: "flex-start"}}> <div style={{marginBottom: "2rem", marginLeft: "1rem", borderRadius: "100%", backgroundImage: `url(${Bubble5})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "top", height: "80px", width:"80px"}}></div> </div>
                <div 
                    className={style.feb_intro_floating}
                    data-aos="zoom-in"
                    data-aos-duration="1200"
                    data-aos-delay="500"
                    style={{display: "flex", justifyContent: "flex-end"}}> <div style={{marginRight: "1rem", borderRadius: "100%", backgroundImage: `url(${Bubble6})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "left", height: "111px", width:"111px"}}></div> </div>
                <div 
                    className={style.feb_intro_floating}
                    data-aos="zoom-in"
                    data-aos-duration="1200"
                    data-aos-delay="200"
                    style={{display: "flex", justifyContent: "flex-start"}}> <div style={{borderRadius: "100%", backgroundColor: "lightgray", backgroundImage: `url(${Bubble7})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", height: "69px", width:"69px"}}></div> </div>
                <div 
                    className={style.feb_intro_floating}
                    data-aos="zoom-in"
                    data-aos-duration="1200"
                    data-aos-delay="600"
                    style={{display: "flex", justifyContent: "flex-end"}}> <div style={{marginRight: "2rem", borderRadius: "100%", backgroundImage: `url(${Bubble8})`, backgroundRepeat: "no-repeat", backgroundSize: "190%", backgroundPosition: "right", height: "118px", width:"118px"}}></div> </div>
            </div>

        </div>
    );
}